$(document).foundation();

//---------------------------------------------------------
//  Animation
//---------------------------------------------------------
var rellax = new Rellax('.rellax');

function isInViewport(el, tolerace) {
    const rect = el.getBoundingClientRect();

    let tolerance = tolerace || 0;

    let isinview = (
      rect.top >= tolerance &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );

    // returns true or false based on whether or not the element is in viewport
    return isinview; 
}

window.addEventListener('DOMContentLoaded',() => {
    const pageElements = document.querySelectorAll('[animate]');
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            entry.isIntersecting && entry.target.classList.add('in-view');
        });
    });
    pageElements.forEach(element => {
        observer.observe(element);
    });    
});
//---------------------------------------------------------


//---------------------------------------------------------
//  Menu
//---------------------------------------------------------
$('.sub-menu-item').mouseenter(function() {
    $(this).parent().children('.sub-menu-item').each(function () {
        $(this).removeClass('active');
    });
    $(this).addClass('active');
});

$(document).on("click", ".flyout-menu-button", function() {
    $(this).toggleClass('open');
    $('#flyout-menu').toggleClass('open');
    $('#header').toggleClass('menu-open');
});

$(document).on("click", ".open-mobile-submenu", function() {
    $(this).parent().toggleClass('open');
});
//---------------------------------------------------------


//---------------------------------------------------------
//  Pages
//---------------------------------------------------------
if ($('.Blog').length > 0) {
   
    $(document).ready(function () {
        $.ajax({
            url: '/ajax/news',
            type: 'GET',
            success: function (data) {
                $('#news-container').html(data);
            }
        });
    });
    
    $(document).on('click', '.page-next, .page', function(e) {
        e.preventDefault();
        if($(this).attr('href')){
            loadNextItems($(this).attr('href'));
        }
    });
    
    function loadNextItems(nextLink) {
        $.ajax({
            url: nextLink,
            type: 'GET',
            success: function (data) {
                $('#news-container').html(data);
                var targetOffset = $("#news-container").offset().top;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 1000);
            }
        });
    }

}//End Blog

if ($('.ResourcesPage').length > 0) {
   
    $(document).ready(function () {

        var catFilter =  $(".cat-tab.active").first().data("cat") || "search";
        if ($('.cat-tabs').hasClass('non-english')) {
            if ($(".cat-tab.active").first().data("cat")) {
                catFilter = $(".cat-tab.active").first().data("cat") || "search";
            } else {
                catFilter =  'product-supplements';
            }
        } 

        if (catFilter.length > 0)
            $('.cat-tab[data-cat="'+catFilter+'"]').trigger('click');
        else {
            $('.featured-resources-grid').removeClass('hide');
        }
    });

    $(document).on('click', '.cat-tab', function() {
        var self = $(this);
        var cat = self.data('cat');
        
        window.history.pushState(null, "The Learning Center", "/resources/" + cat + location.hash + location.search);

        $('.cat-tab').removeClass('active');
        self.addClass('active');
        $('#product-guide-filters').addClass('hide');        

        $('.product-guides-cell').addClass('hide');
        $('.resource-cell').addClass('hide');
        $('.featured-resources-grid').addClass('hide');
    
        switch (cat) {
            case 'product-supplements':
                $('.management-guides-resource-cell').addClass('hide');
                $('.articles-resource-cell').addClass('hide');
                $('#product-guide-filters').removeClass('hide');
                $('.product-guides-cell').removeClass('hide');
                $('.button','#product-guide-filters').addClass('light');
                $('.button','#product-guide-filters').first().removeClass('light');
                break;
            case 'featured':
                $('.featured-resources-grid').removeClass('hide');
                $('.all-resources-grid').addClass('hide');
                $('.articles-resource-cell').removeClass('hide');
                $('.videos-resource-cell').removeClass('hide');
                $('.management-guides-resource-cell:not(.hero-guide)').removeClass('hide');
                $('.posters-resource-cell').removeClass('hide');
                $('.product-resource-cell.featured').removeClass('hide');
                break;
            default:
                $('.'+cat+'-resource-cell').removeClass('hide');
        }

    });

    $('#product-guide-filters').on('click', '.button', function() {
        var self = $(this);
        var id = self.data('product');

        $('.button','#product-guide-filters').addClass('light');
        self.removeClass('light');

        if (id) {
            $('.product-guides-cell').addClass('hide');
            $('.product-'+id).removeClass('hide');
        } else {
            $('.product-guides-cell').removeClass('hide');
        }

    });

}//End ResourcesPage

if ($('.ResourcePage').length > 0) {
   
    $(document).on("submit", "#download-form", function (e) {
        e.preventDefault();

        $("#form-submit").hide();
        $("#form-loader").show();

        $.ajax({type: "POST", url: '/ajax/resource', dataType: 'json', data: $(this).serialize() })
        .done(function(data) {
            $('.download-form').fadeOut(400);
            $('.thank-you').delay(400).fadeIn(400);
        })
        .fail (function (xhr) {
            console.log('Error: ' + xhr.responseText);
            $("#form-submit").show();
            $("#form-loader").hide();
        });
    });

}//End ResourcePage

if ($('.ArticleHolderPage').length > 0) {
   
    $(document).ready(function () {
        $.ajax({
            url: '/ajax/articles',
            type: 'GET',
            success: function (data) {
                $('#news-container').html(data);
            }
        });
    });
    
    $(document).on('click', '.page-next, .page', function(e) {
        e.preventDefault();
        if($(this).attr('href')){
            loadNextItems($(this).attr('href'));
        }
    });
    
    function loadNextItems(nextLink) {
        $.ajax({
            url: nextLink,
            type: 'GET',
            success: function (data) {
                $('#news-container').html(data);
                var targetOffset = $("#news-container").offset().top;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 1000);
            }
        });
    }

}//End ArticleHolderPage


if ($('.AcademyLandingPage').length > 0) {

    $('#signup-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#signup-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#signup-form').removeClass('loading');
                var signupMessage = $('#signup-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    location.reload();
                } else {
                    signupMessage.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#login-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#login-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#login-form').removeClass('loading');
                var loginMessage = $('#login-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    location.reload();
                } else {
                    loginMessage.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#resetpassword-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $(this).addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#resetpassword-form').removeClass('loading');
                var message = $('#resetpassword-error-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    window.location = '/cobb-academy';
                } else {
                    message.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#forgotpassword-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#forgotpassword-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#forgotpassword-form').removeClass('loading');
                var errorMessage = $('#forgotpassword-error-message');
                var successMessage = $('#forgotpassword-success-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    successMessage.html(data.message).show();
                    errorMessage.hide();
                    $('#forgotpassword-form').hide();
                } else {
                    errorMessage.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#Password_ConfirmPassword').attr('placeholder', 'Confirm Password');

    $('#account-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#account-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#account-form').removeClass('loading');
                var errorMessage = $('#account-error-message');
                var successMessage = $('#account-success-message');
                var data = JSON.parse(resp);
                console.log(resp);
                
                errorMessage.html(data.message).show();

                if (data.type == 'success') {
                    successMessage.html(data.message).show();
                    errorMessage.hide();
                    location.reload();
                } 
            }
        });
        return false;
    });

}//End AcademyLandingPage

if ($('.AcademyPage').length > 0) {

    $('#signup-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#signup-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#signup-form').removeClass('loading');
                var signupMessage = $('#signup-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    location.reload();
                } else {
                    signupMessage.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#login-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#login-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#login-form').removeClass('loading');
                var loginMessage = $('#login-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    location.reload();
                } else {
                    loginMessage.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#resetpassword-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $(this).addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#resetpassword-form').removeClass('loading');
                var message = $('#resetpassword-error-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    window.location = '/cobb-academy';
                } else {
                    message.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#forgotpassword-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#forgotpassword-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#forgotpassword-form').removeClass('loading');
                var errorMessage = $('#forgotpassword-error-message');
                var successMessage = $('#forgotpassword-success-message');
                var data = JSON.parse(resp);
                if (data.type == 'success') {
                    successMessage.html(data.message).show();
                    errorMessage.hide();
                    $('#forgotpassword-form').hide();
                } else {
                    errorMessage.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#account-form').submit(function() {
        if ($(this).hasClass('loading')) return false;
        $('#account-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(resp){
                $('#account-form').removeClass('loading');
                var errorMessage = $('#account-error-message');
                var successMessage = $('#account-success-message');
                var data = JSON.parse(resp);
                console.log(resp);
                errorMessage.html(data.message).show();

                if (data.type == 'success') {
                    successMessage.html(data.message).show();
                    errorMessage.hide();
                    location.reload();
                } else {
                    errorMessage.html(data.message).show();
                }
            }
        });
        return false;
    });

    $('#Password_ConfirmPassword').attr('placeholder', 'Confirm Password');

}//End AcademyPage

if ($('.countdown').length) {

    $('.countdown').each(function(index, el) {

        // Set the date we're counting down to
        // var countDownDate = new Date("Feb 28, 2022 00:00:00").getTime();
        var releaseDate = el.dataset.date;
        var countDownDate = new Date(releaseDate).getTime();

        // Update the count down every 1 second
        var x = setInterval(function() {

          // Get today's date and time
          var now = new Date().getTime();

          // Find the distance between now and the count down date
          var distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Display the result in the element with id="demo"
          el.innerHTML = '<span class="countdown-cell">' + days + '<span class="countdown-label">Days</span></span>' + '<span class="countdown-cell">' + hours + ' <span class="countdown-label">Hours</span></span>'
          + '<span class="countdown-cell">' + minutes + ' <span class="countdown-label">MINS</span></span>' + '<span class="countdown-cell">' + seconds + ' <span class="countdown-label">SECS</span></span>';

          // If the count down is finished, write some text
          // if (distance < 0) {
          //   clearInterval(x);
          //   document.getElementById("countdown").innerHTML = "EXPIRED";
          // }
        }, 1000);

    });
}

if ($('.AcademyModulePage').length > 0) {

    if ($('.video-scroller').length > 0) {
        $('.video-scroller').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            autoplay:false,
            autoplaySpeed: 9000,
            speed: 600,
            dots: false,
            appendArrows: $('.video-scroller-nav'),
            prevArrow:'<a class="video-scroller-prev"><i class="fal fa-long-arrow-left"></i></a>',
            nextArrow:'<a class="video-scroller-next"><i class="fal fa-long-arrow-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    $(document).on('click', '.btn-play-video', function() {
        var itemID = $(this).data('item');
        var videoID = $(this).data('video');
        var transcript = $(this).data('transcript');
        var reveal = $('#video-scroller-reveal');
        var embed = '<iframe id="video-'+videoID+'" src="https://player.vimeo.com/video/'+videoID+'" width="1280" height="720" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
        reveal.find('.content').html(embed);
        reveal.foundation('open');
        $('.accordion').addClass('hide');
        if (transcript) {
            $('#transcript-accordion-'+itemID).removeClass('hide');
        }
        var player = new Vimeo.Player($('#video-'+videoID));
        player.play().then(function() {
            // then
        }).catch(function(error) {
            switch (error.name) {
                case 'PasswordError':
                    // the video is password-protected and the viewer needs to enter the
                    // password first
                    break;
    
                case 'PrivacyError':
                    // the video is private
                    break;
    
                default:
                    // some other error occurred
                    break;
            }
        });
    
    });
    
    $('[data-reveal]').on('close.zf.trigger', function(){
        var reveal = $(this);
        console.log('close');
        var embedContent = reveal.find('iframe');
        if (embedContent.length) {
            if (embedContent.attr('src').includes('vimeo')) {
                var player = new Vimeo.Player(embedContent[0]);
                player.pause().then(function() {
                }).catch(function(error) {
                    switch (error.name) {
                        case 'PasswordError':
                            console.log('vimeo error')
                        break;
    
                        case 'PrivacyError':
                            console.log('vimeo error')
                            break;
    
                        default:
                            console.log('vimeo error')
                            break;
                    }
                });
            }
        }
    });
    
    $('[data-reveal]').on('closed.zf.trigger', function(){
        var reveal = $(this);
        console.log('closed');
        var embedContent = reveal.find('iframe');
        if (embedContent.length) {
            if (embedContent.attr('src').includes('vimeo')) {
                var player = new Vimeo.Player(embedContent[0]);
                player.pause().then(function() {
                }).catch(function(error) {
                    switch (error.name) {
                        case 'PasswordError':
                            console.log('vimeo error')
                        break;
    
                        case 'PrivacyError':
                            console.log('vimeo error')
                            break;
    
                        default:
                            console.log('vimeo error')
                            break;
                    }
                });
            }
        }
    });

}//End AcademyModulePage
//---------------------------------------------------------


//---------------------------------------------------------
//  Elements
//---------------------------------------------------------
if ($('.elements__roundedsliderelement').length > 0) {
   
    let progressRSEValue = 0;

    $(document).ready(function() {

        const intervalRSE = setInterval(function() {
          $('.rse-progress-meter').css('width', progressRSEValue/10 + '%');
          progressRSEValue += 1;
          if (progressRSEValue/10 > 100) {
            progressRSEValue=0;
            $('.rounded-slider-next').trigger('click');
          }
        }, 15); 

    });

    $(document).on('click', '.rounded-slider-prev', function() {
        var slider = $(this).parent();
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === 1 ? sliderCount : sliderCurrent - 1;

        $('.rounded-slider-prev').prop("disabled", true);
        $('.rounded-slider-next').prop("disabled", true);

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + sliderCurrent).addClass('inactive');
        slider.find('.slide' + nextSlide).addClass('active');

        slider.find('.slide' + nextSlide).addClass('active').delay(1300).queue(function(){
            $('.rounded-slider-prev').prop("disabled", false);
            $('.rounded-slider-next').prop("disabled", false);
            slider.find('.slide' + sliderCurrent).removeClass('inactive');
            $(this).dequeue();
        });

        slider.data('current', nextSlide);
        progressRSEValue=0;
        return false;
    });

    $(document).on('click', '.rounded-slider-next', function() {
        var slider = $(this).parent();
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === sliderCount ? 1 : sliderCurrent + 1;

        $('.rounded-slider-prev').prop("disabled", true);
        $('.rounded-slider-next').prop("disabled", true);

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + sliderCurrent).addClass('inactive');
        slider.find('.slide' + nextSlide).addClass('active');

        slider.find('.slide' + nextSlide).addClass('active').delay(1300).queue(function(){
            $('.rounded-slider-prev').prop("disabled", false);
            $('.rounded-slider-next').prop("disabled", false);
            slider.find('.slide' + sliderCurrent).removeClass('inactive');
            $(this).dequeue();
        });

        slider.data('current', nextSlide);
        progressRSEValue=0;
        return false;
    });

}//End elements__roundedsliderelement

if ($('.elements__featuredproductelement').length > 0) {
   
    $(document).on('click', '.product-slider-prev', function() {
        var slider = $(this).parent().find('.product-slider-container');
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === 1 ? sliderCount : sliderCurrent - 1;

        var percent = nextSlide/sliderCount*100;
        slider.find('.progress-meter').css('width', percent+'%');

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + sliderCurrent).fadeOut(400);
        slider.find('.slide' + nextSlide).delay(400).fadeIn(0);
        
        slider.find('.slide' + nextSlide).delay(200).queue(function(){
            slider.find('.slide' + nextSlide).addClass('active');
            $(this).dequeue();
        });

        slider.data('current', nextSlide);
        return false;
    });

    $(document).on('click', '.product-slider-next', function() {
        var slider = $(this).parent().find('.product-slider-container');

        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === sliderCount ? 1 : sliderCurrent + 1;

        var percent = nextSlide/sliderCount*100;
        slider.find('.progress-meter').css('width', percent+'%');

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + sliderCurrent).fadeOut(400);
        slider.find('.slide' + nextSlide).delay(400).fadeIn(0);
        
        slider.find('.slide' + nextSlide).delay(200).queue(function(){
            slider.find('.slide' + nextSlide).addClass('active');
            $(this).dequeue();
        });

        slider.data('current', nextSlide);
        return false;
    });

}//End elements__featuredproductelement

if ($('.elements__twocolumnsliderelement').length > 0) {
   
    let progressTCSValue = 0;

    $(document).ready(function() {

        const intervalRSE = setInterval(function() {
          $('.tcs-progress-meter').css('width', progressTCSValue/10 + '%');
          progressTCSValue += 1;
          if (progressTCSValue/10 > 100) {
            progressTCSValue=0;
            $('.tc-slider-next').trigger('click');
          }
        }, 14); 

    });

    $(document).on('click', '.tc-slider-prev', function() {
        var slider = $(this).parent().parent().parent();
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === 1 ? sliderCount : sliderCurrent - 1;

        $('.tc-slider-prev').prop("disabled", true);
        $('.tc-slider-next').prop("disabled", true);

        slider.find('.slide' + sliderCurrent).find('.content').fadeOut(500);
        slider.find('.slide' + nextSlide).find('.content').delay(500).fadeIn(700);

        slider.find('.slide' + nextSlide).find('.image-content').css('z-index', 300);
        slider.find('.slide' + sliderCurrent).find('.image-content').css('z-index', 1);
        
        slider.find('.slide' + nextSlide).find('.image-content').animate({width:'100%'},700);
        slider.find('.slide' + sliderCurrent).find('.image-content').delay(700).animate({width:'0%'});
        


        slider.find('.slide' + nextSlide).addClass('active').delay(700).queue(function(){
            $('.tc-slider-prev').prop("disabled", false);
            $('.tc-slider-next').prop("disabled", false);
            slider.find('.slide' + sliderCurrent).removeClass('active');
            $(this).dequeue();
        });

        progressTCSValue=0;
        slider.data('current', nextSlide);
        return false;
    });

    $(document).on('click', '.tc-slider-next', function() {
        var slider = $(this).parent().parent().parent();
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === sliderCount ? 1 : sliderCurrent + 1;

        $('.tc-slider-prev').prop("disabled", true);
        $('.tc-slider-next').prop("disabled", true);

        slider.find('.slide' + sliderCurrent).find('.content').fadeOut(500);
        slider.find('.slide' + nextSlide).find('.content').delay(500).fadeIn(700);

        slider.find('.slide' + nextSlide).find('.image-content').css('z-index', 300);
        slider.find('.slide' + sliderCurrent).find('.image-content').css('z-index', 1);
       
        slider.find('.slide' + nextSlide).find('.image-content').animate({width:'100%'},700);
        slider.find('.slide' + sliderCurrent).find('.image-content').delay(700).animate({width:'0%'});

        slider.find('.slide' + nextSlide).addClass('active').delay(700).queue(function(){
            $('.tc-slider-prev').prop("disabled", false);
            $('.tc-slider-next').prop("disabled", false);
            slider.find('.slide' + sliderCurrent).removeClass('active');
            $(this).dequeue();
        });

        progressTCSValue=0;
        slider.data('current', nextSlide);
        return false;
    });

}//End elements__twocolumnsliderelement

if ($('.elements__employeespotlightelement').length > 0) {
   
    $(document).on('click', '.spotlight-slider-prev', function() {
        var slider = $(this).closest('.content').find('.slides');
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === 1 ? sliderCount : sliderCurrent - 1;

        var percent = nextSlide/sliderCount*100;
        $(this).parent().find('.progress-meter').css('width', percent+'%');

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + nextSlide).addClass('active');

        slider.find('.slide' + sliderCurrent).find('.video-resource-tile').fadeOut(500);
        slider.find('.slide' + nextSlide).find('.video-resource-tile').delay(500).fadeIn(700);

        slider.data('current', nextSlide);
        return false;
    });

    $(document).on('click', '.spotlight-slider-next', function() {
        var slider = $(this).closest('.content').find('.slides');
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === sliderCount ? 1 : sliderCurrent + 1;

        var percent = nextSlide/sliderCount*100;
        $(this).parent().find('.progress-meter').css('width', percent+'%');

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + nextSlide).addClass('active');

        slider.find('.slide' + sliderCurrent).find('.video-resource-tile').fadeOut(500);
        slider.find('.slide' + nextSlide).find('.video-resource-tile').delay(500).fadeIn(700);

        slider.data('current', nextSlide);
        return false;
    });

}//End elements__employeespotlightelement

if ($('.elements__historyelement').length > 0) {
   
    $(document).on('click', '.history-slider-prev', function() {
        var slider = $('.history-slides');
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === 1 ? sliderCount : sliderCurrent - 1;
        var percent = nextSlide/sliderCount*100;
        $('.history-meter').css('width', percent+'%');
        var decade = slider.find('.slide' + nextSlide).data('decade');

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + nextSlide).addClass('active');
        slider.find('.slide' + nextSlide).removeClass('right');
        slider.find('.slide' + nextSlide).removeClass('left');

        for (let i = 1; i <= sliderCount; i++) {
            if (i < nextSlide){
                slider.find('.slide' + i).removeClass('right');
                slider.find('.slide' + i).removeClass('left');
                slider.find('.slide' + i).addClass('left');
            }
            if (i > nextSlide){
                slider.find('.slide' + i).removeClass('right');
                slider.find('.slide' + i).removeClass('left');
                slider.find('.slide' + i).addClass('right');
            }
        }


        $('.decade').removeClass('active');
        $('#'+decade).addClass('active');

        slider.data('current', nextSlide);
        return false;
    });

    $(document).on('click', '.history-slider-next', function() {
        var slider = $('.history-slides');
        var sliderCount = slider.data('count');
        var sliderCurrent = slider.data('current');
        var nextSlide = sliderCurrent === sliderCount ? 1 : sliderCurrent + 1;
        var percent = nextSlide/sliderCount*100;
        $('.history-meter').css('width', percent+'%');
        var decade = slider.find('.slide' + nextSlide).data('decade');

        slider.find('.slide' + sliderCurrent).removeClass('active');
        slider.find('.slide' + nextSlide).addClass('active');
        slider.find('.slide' + nextSlide).removeClass('right');
        slider.find('.slide' + nextSlide).removeClass('left');

        for (let i = 1; i <= sliderCount; i++) {
            if (i < nextSlide){
                slider.find('.slide' + i).removeClass('right');
                slider.find('.slide' + i).removeClass('left');
                slider.find('.slide' + i).addClass('left');
            }
            if (i > nextSlide){
                slider.find('.slide' + i).removeClass('right');
                slider.find('.slide' + i).removeClass('left');
                slider.find('.slide' + i).addClass('right');
            }
        }

        $('.decade').removeClass('active');
        $('#'+decade).addClass('active');
        slider.data('current', nextSlide);
        return false;
    });

    $(document).on('click', '.decade', function() {
        var nextSlide= $(this).data("slide");
       
        var slider = $('.slide'+nextSlide).parent();
        var sliderCount = slider.data('count');
        var percent = nextSlide/sliderCount*100;


        slider.find('.progress-meter').css('width', percent+'%');
        var decade = slider.find('.slide' + nextSlide).data('decade');

        slider.find('.active').removeClass('active');
        slider.find('.slide' + nextSlide).addClass('active');
        slider.find('.slide' + nextSlide).removeClass('right');
        slider.find('.slide' + nextSlide).removeClass('left');

        for (let i = 1; i <= sliderCount; i++) {
            if (i < nextSlide){
                slider.find('.slide' + i).removeClass('right');
                slider.find('.slide' + i).removeClass('left');
                slider.find('.slide' + i).addClass('left');
            }
            if (i > nextSlide){
                slider.find('.slide' + i).removeClass('right');
                slider.find('.slide' + i).removeClass('left');
                slider.find('.slide' + i).addClass('right');
            }
        }

        $('.decade').removeClass('active');
        $('#'+decade).addClass('active');
        slider.data('current', nextSlide);
        return false;
    });

}// End elements__historyelement

if ($('.elements__researchinitiativearticleelement').length > 0) {
    
    $(document).ready(function () {
        $.ajax({
            url: '/ajax/criarticles',
            type: 'GET',
            success: function (data) {
                $('#cri-container').html(data);
            }
        });

        
        
    });

    $(document).on('click', '.page-next, .page', function(e) {
        e.preventDefault();
        if($(this).attr('href')){
            loadNextItems($(this).attr('href'));
        }
    });

    function loadNextItems(nextLink) {
        $.ajax({
            url: nextLink,
            type: 'GET',
            success: function (data) {
                $('#cri-container').html(data);
                var targetOffset = $("#top-of-cri").offset().top;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 1000);
            }
        });
    }

}// End elements__researchinitiativearticleelement


if ($('.elements__twocolumnvideoelement').length > 0) {
    
    $(document).on('click', '.video-link', function() {

        var id = $(this).data('video');
        var videomodal = $(this).data('rv');
        var type = $(this).data('video-type');
        var modal = $('#video-embed'+videomodal);
        var ytPlayer;

        if (type == 'vimeo') {
            var embed = '<iframe id="vimeo-player" width="800" height="500" src="https://player.vimeo.com/video/'+ id +'?autoplay=1&api=1&player_id=vimeo-player" frameborder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
            // populate and open video modal
            modal.find('.video-wrap').html(embed);
    
            var iframe = $('#vimeo-player')[0];
            var player = new Vimeo.Player(iframe);
            var vidTitle,
                vidUrl,
                vidDuration,
                quarterComplete = false,
                halfComplete = false,
                threeQuarterComplete = false;
    
            player.on('play', function(data) {
                var time = Math.round(data.seconds);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'gtm.video',
                    'gtm.videoProvider': 'Vimeo',
                    'gtm.videoStatus': 'start-'+time,
                    'gtm.videoUrl': vidUrl,
                    'gtm.videoTitle': vidTitle,
                    'gtm.videoDuration': vidDuration,
                    'gtm.videoCurrentTime': time,
                    'gtm.videoVisible': true,
                });
    
            });
    
            player.getVideoTitle().then(function(title) {
                vidTitle = title;
            });
            player.getVideoUrl().then(function(url) {
                vidUrl = url;
            });
            player.getDuration().then(function(d) {
                vidDuration = d;
            });
    
            player.on('pause', function(data) {
                var time = Math.round(data.seconds);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'gtm.video',
                    'gtm.videoProvider': 'Vimeo',
                    'gtm.videoStatus': 'pause-'+time,
                    'gtm.videoUrl': vidUrl,
                    'gtm.videoTitle': vidTitle,
                    'gtm.videoDuration': vidDuration,
                    'gtm.videoCurrentTime': time,
                    'gtm.videoVisible': true,
                });
            });
    
            player.on('ended', function(data) {
                var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
                pushProgress('100',vidDuration,v);
            });
    
            player.on('timeupdate', function(data) {
                var progress = Math.round(data.percent*100);
                var t = Math.round(data.seconds);
                var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
                switch (progress) {
                    case 25:
                        if (!quarterComplete) {pushProgress('25',t,v); quarterComplete=true;};
                        break;
                    case 50:
                        if (!halfComplete) {pushProgress('50',t,v); halfComplete=true;};
                        break;
                    case 75:
                        if (!threeQuarterComplete) {pushProgress('75',t,v); threeQuarterComplete=true;};
                        break;
                    default:
    
                }
            });
    
        } else if (type == 'youtube') {
            var embed = '<iframe id="youtube-player" width="560" height="315" src="https://www.youtube.com/embed/'+id+'?enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    
            // populate and open video modal
            modal.find('.video-wrap').html(embed);
    
            try {
                // init yt player api
                ytPlayer = new YT.Player('youtube-player', {
                    events: {
                        'onReady': onPlayerReady
                    }
                });
            }
            catch {
                console.error("Failed to initalize Youtube API");
            }
        }
    
        modal.foundation('open');
    });

    $(document).on("closed.zf.reveal", ".popup-video", function() {
        $(this).find('.video-wrap').html("");
    });
    
}// End elements__twocolumnvideoelement


$(document).on('click', '.video-resource-tile', function() {

    var id = $(this).data('video');
    var type = $(this).data('video-type');
    var modal = $('#video-embed');
    var ytPlayer;

    if (type == 'vimeo') {
        var embed = '<iframe id="vimeo-player" width="800" height="500" src="https://player.vimeo.com/video/'+ id +'?autoplay=1&api=1&player_id=vimeo-player" frameborder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
        // populate and open video modal
        modal.find('.video-wrap').html(embed);

        var iframe = $('#vimeo-player')[0];
        var player = new Vimeo.Player(iframe);
        var vidTitle,
            vidUrl,
            vidDuration,
            quarterComplete = false,
            halfComplete = false,
            threeQuarterComplete = false;

        player.on('play', function(data) {
            var time = Math.round(data.seconds);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm.video',
                'gtm.videoProvider': 'Vimeo',
                'gtm.videoStatus': 'start-'+time,
                'gtm.videoUrl': vidUrl,
                'gtm.videoTitle': vidTitle,
                'gtm.videoDuration': vidDuration,
                'gtm.videoCurrentTime': time,
                'gtm.videoVisible': true,
            });

        });

        player.getVideoTitle().then(function(title) {
            vidTitle = title;
        });
        player.getVideoUrl().then(function(url) {
            vidUrl = url;
        });
        player.getDuration().then(function(d) {
            vidDuration = d;
        });

        player.on('pause', function(data) {
            var time = Math.round(data.seconds);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm.video',
                'gtm.videoProvider': 'Vimeo',
                'gtm.videoStatus': 'pause-'+time,
                'gtm.videoUrl': vidUrl,
                'gtm.videoTitle': vidTitle,
                'gtm.videoDuration': vidDuration,
                'gtm.videoCurrentTime': time,
                'gtm.videoVisible': true,
            });
        });

        player.on('ended', function(data) {
            var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
            pushProgress('100',vidDuration,v);
        });

        player.on('timeupdate', function(data) {
            var progress = Math.round(data.percent*100);
            var t = Math.round(data.seconds);
            var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
            switch (progress) {
                case 25:
                    if (!quarterComplete) {pushProgress('25',t,v); quarterComplete=true;};
                    break;
                case 50:
                    if (!halfComplete) {pushProgress('50',t,v); halfComplete=true;};
                    break;
                case 75:
                    if (!threeQuarterComplete) {pushProgress('75',t,v); threeQuarterComplete=true;};
                    break;
                default:

            }
        });

    } else if (type == 'youtube') {
        var embed = '<iframe id="youtube-player" width="560" height="315" src="https://www.youtube.com/embed/'+id+'?enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

        // populate and open video modal
        modal.find('.video-wrap').html(embed);

        try {
            // init yt player api
            ytPlayer = new YT.Player('youtube-player', {
                events: {
                    'onReady': onPlayerReady
                }
            });
        }
        catch {
            console.error("Failed to initalize Youtube API");
        }
    }

    modal.foundation('open');
    // window.__vimeoRefresh()
    
    
});

if ($('#countdown').length > 0) {
    var countdownEl = document.getElementById("countdown");
    var eventDate = countdownEl.dataset.date;
    var countDownDate = new Date(eventDate).getTime();
    
    var x = setInterval(function() {
    
      var now = new Date().getTime();
    
      var distance = countDownDate - now;
    
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    countdownEl.innerHTML = days + "<span>days</span> " + hours + "<span>hrs</span> "
    + minutes + "<span>min</span> " + seconds + "<span>sec</span> ";
    
      // If the count down is finished, don't show anything
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("demo").innerHTML = "";
      }
    }, 1000);

}

$(document).on("closed.zf.reveal", "#video-embed", function() {
    $(this).find('.video-wrap').html("");
});

//---------------------------------------------------------

$(document).on('click', '#close-search', function() {
    $('#search-container').removeClass('active');
});

$(document).on('click', '#open-search', function() {
    $('#search-container').addClass('active');
});
